module.exports = __webpack_public_path__ + "static/img/tubiao_chengse.f395413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/tubiao_chengse.png
// module id = Rrk1
// module chunks = 2